import FloatingActionMenu from './FloatingActionMenu.component';

export default FloatingActionMenu;